/* =========================================================
   BM BLEND IDEAS HELPER — MODAL VERSION (TAG-GATED)
   ---------------------------------------------------------
   What this script does:
   1. Shows a "Suggested blends for [selected scent]" helper
      under Infinite Options Scent 1.
   2. Opens a modal with pairing suggestions for the selected
      scent, filtered to only scents currently available in
      the dropdown.
   3. Styles the modal using the scent's accent color.
   4. Adds a "More about this scent →" link in the modal
      header that opens the Our Scents page in a new tab
      and jumps directly to that scent's full scent box.

   Requires:
   - window.PR_IS_BLENDED or window.PR_IS_CUSTOM_SIGNATURE
     (set in product template)
   - #bm-blend-data present (snippet)
   - select[name="properties[Scent 1]"] present (Infinite Options)
========================================================= */

(function () {
  var SELECT_S1 = 'select[name="properties[Scent 1]"]';
  var DATA_ROOT = '#bm-blend-data';
  var IO_ROOT = '#infiniteoptions-container';

  // Quick kill switch if you ever need it
  var BM_MODAL_ENABLED = true;

  // TAG GATES (from your product template globals)
  function isAllowedProduct() {
    var isBlended = (window.PR_IS_BLENDED === true || window.PR_IS_BLENDED === 'true');
    var isCustomSignature = (window.PR_IS_CUSTOM_SIGNATURE === true || window.PR_IS_CUSTOM_SIGNATURE === 'true');
    return isBlended || isCustomSignature;
  }

  var DEFAULT_ACCENT = '#a77815';

  // Converts #hex OR rgb() OR rgba() into rgba(r,g,b,opacity)
  function colorToRgba(color, opacity) {
    if (!color) return 'rgba(167,120,21,' + opacity + ')';

    var c = String(color).trim();

    // rgba(r,g,b,a) -> swap alpha
    if (c.indexOf('rgba(') === 0) {
      var m1 = c.match(/rgba\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*[\d.]+\s*\)/i);
      if (m1) return 'rgba(' + m1[1] + ',' + m1[2] + ',' + m1[3] + ',' + opacity + ')';
    }

    // rgb(r,g,b)
    if (c.indexOf('rgb(') === 0) {
      var m2 = c.match(/rgb\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)/i);
      if (m2) return 'rgba(' + m2[1] + ',' + m2[2] + ',' + m2[3] + ',' + opacity + ')';
    }

    // hex
    if (c.charAt(0) === '#') c = c.slice(1);
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];

    if (c.length === 6) {
      var r = parseInt(c.substring(0, 2), 16);
      var g = parseInt(c.substring(2, 4), 16);
      var b = parseInt(c.substring(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    }

    // fallback gold
    return 'rgba(167,120,21,' + opacity + ')';
  }

  function normalizeName(str) {
    if (!str) return '';

    return String(str)
      .toLowerCase()
      .trim()
      .replace(/[®™]/g, '')
      .replace(/[’‘]/g, "'")
      .replace(/[—–]/g, '-')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // WM-08: Shared base identities/aliases/colors come from server-rendered registry data.
  // Recipes and currently offered app options remain separate authorities.
  var registryRoot = null, registryById = Object.create(null), registryByName = Object.create(null);
  function readRegistry() {
    var root = document.querySelector(DATA_ROOT);
    if (!root || root === registryRoot) return;
    var byId = Object.create(null), byName = Object.create(null);
    root.querySelectorAll('.bm-fragrance').forEach(function (item) {
      var record = { id: item.dataset.prScentId, name: item.dataset.prName, color: item.dataset.prColor };
      byId[record.id] = record;
      [record.name].concat(JSON.parse(item.dataset.prAliases || '[]')).forEach(function (name) {
        var key = normalizeName(name);
        if (byName[key] && byName[key].id !== record.id) throw Error('Duplicate fragrance alias in registry');
        byName[key] = record;
      });
    });
    registryRoot = root; registryById = byId; registryByName = byName;
  }
  function resolveFragrance(name) { readRegistry(); return registryByName[normalizeName(name)] || null; }
  function getInfoHrefForScentName(name) {
    var record = resolveFragrance(name);
    return record ? '/pages/our-scents#' + encodeURIComponent(record.id) : '';
  }

  function getBlendData() {
    var root = document.querySelector(DATA_ROOT);
    if (!root) return null;

    var map = {};

    root.querySelectorAll('.bm-scent-block').forEach(function (block) {
      readRegistry();
      var scentId = block.getAttribute('data-scent-id') || '';
      var scent = registryById[scentId];
      if (!scent) return;

      var partners = [];

      block.querySelectorAll('.bm-partner').forEach(function (p) {
        var partnerId = p.getAttribute('data-partner-id') || '';
        var partner = registryById[partnerId];
        if (!partner) return;

        partners.push({
          partnerDisplay: partner.name,
          partnerNorm: partnerId,
          desc: (p.textContent || '').trim()
        });
      });

      map[scentId] = {
        scentDisplay: scent.name,
        partners: partners
      };
    });

    return map;
  }

  function getAvailableOptions(selectEl) {
    var out = [];

    Array.prototype.forEach.call(selectEl.options, function (opt) {
      var v = (opt && opt.value || '').trim();
      if (!v) return;
      if (opt.disabled) return;

      out.push({
        value: v,
        norm: (resolveFragrance(v) || {}).id || normalizeName(v)
      });
    });

    return out;
  }

  function getAccentForScentName(name) {
    var record = resolveFragrance(name);
    return record && record.color || DEFAULT_ACCENT;
  }
  window.PR_BM_SCENT_ACCENT = getAccentForScentName;
  document.dispatchEvent(new Event('bm-scent-accent-ready'));

  // Stop IO/theme handlers from hijacking taps/clicks
  function stopCapture(e) {
    if (!e) return;

    e.stopPropagation();

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
  }

  function stopClick(e) {
    if (!e) return false;

    e.preventDefault();
    e.stopPropagation();

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    return false;
  }

  function bindKillCapture(el) {
    if (!el) return;

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      el.addEventListener(evt, stopCapture, true);
    });
  }

  // Helper: render description with italic memory after dash
  function setDescWithItalicMemory(descEl, rawText) {
    var t = String(rawText || '').trim();

    descEl.textContent = '';

    if (!t) return;

    var idx = t.indexOf('—');
    var dashChar = '—';

    if (idx === -1) {
      idx = t.indexOf('–');
      dashChar = '–';
    }

    if (idx === -1) {
      descEl.textContent = t;
      return;
    }

    var before = t.slice(0, idx).trim();
    var after = t.slice(idx + 1).trim();

    if (before) {
      descEl.appendChild(
        document.createTextNode(before + ' ' + dashChar + ' ')
      );
    }

    var em = document.createElement('em');
    em.textContent = after;

    descEl.appendChild(em);
  }

  // ---------- MODAL ----------

  var MODAL_ID = 'bm-modal';

  var modal;
  var modalCard;
  var modalTitle;
  var modalAccentLine;
  var modalList;
  var modalDisclaimer;
  var modalInfoLink;

  function ensureModal() {
    if (document.getElementById(MODAL_ID)) return;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'bm-modal';
    modal.setAttribute('aria-hidden', 'true');

    var overlay = document.createElement('div');
    overlay.className = 'bm-modal__overlay';

    var card = document.createElement('div');
    card.className = 'bm-modal__card';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');

    var closeBtn = document.createElement('button');
    closeBtn.className = 'bm-modal__close';
    closeBtn.type = 'button';
    closeBtn.innerHTML = '×';

    var titleRow = document.createElement('div');
    titleRow.className = 'bm-title-row';

    var title = document.createElement('div');
    title.className = 'bm-title';

    var subtitle = document.createElement('div');
    subtitle.className = 'bm-subtitle';
    subtitle.textContent = 'blends beautifully with:';

  var infoLink = document.createElement('a');
infoLink.className = 'bm-more-info';
infoLink.textContent = 'Explore this scent';
infoLink.target = '_blank';
infoLink.rel = 'noopener noreferrer';
infoLink.style.display = 'none';

    titleRow.appendChild(title);

    var linkRow = document.createElement('div');
    linkRow.className = 'bm-link-row';
    linkRow.appendChild(infoLink);

    titleRow.appendChild(linkRow);

    var accentLine = document.createElement('div');
    accentLine.className = 'bm-accent-line';
    accentLine.style.backgroundColor = DEFAULT_ACCENT;

    var list = document.createElement('div');
    list.className = 'bm-list';

    var disclaimer = document.createElement('div');
    disclaimer.className = 'bm-disclaimer';
    disclaimer.textContent =
      'These are just starting ideas. Seasonal scents may open up new combinations throughout the year. Trust your nose — sometimes the best blends are the ones you didn’t expect.';

    card.appendChild(closeBtn);
    card.appendChild(titleRow);
    card.appendChild(accentLine);
    card.appendChild(subtitle);
    card.appendChild(list);
    card.appendChild(disclaimer);

    modal.appendChild(overlay);
    modal.appendChild(card);

    document.body.appendChild(modal);

    modalCard = card;
    modalTitle = title;
    modalAccentLine = accentLine;
    modalList = list;
    modalDisclaimer = disclaimer;
    modalInfoLink = infoLink;

    bindKillCapture(card);
    bindKillCapture(closeBtn);
    bindKillCapture(infoLink);

    overlay.addEventListener('click', function (e) {
      stopClick(e);
      closeModal();
      return false;
    });

    closeBtn.addEventListener('click', function (e) {
      stopClick(e);
      closeModal();
      return false;
    });

    infoLink.addEventListener('click', function (e) {
      stopCapture(e);
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;

      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }

  function isOpen() {
    var el = document.getElementById(MODAL_ID);

    return el && el.classList.contains('is-open');
  }

  function openModal() {
    ensureModal();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('bm-modal-open');
    document.body.classList.add('bm-modal-open');
  }

  function closeModal() {
    var el = document.getElementById(MODAL_ID);

    if (!el) return;

    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('bm-modal-open');
    document.body.classList.remove('bm-modal-open');
  }

  function fillModal(selected, filtered) {
    ensureModal();

    var accent = getAccentForScentName(selected) || DEFAULT_ACCENT;
    var infoHref = getInfoHrefForScentName(selected);

    // Keep modal background WHITE (no tint)
    modalAccentLine.style.backgroundColor = accent;
    modalCard.style.borderColor = accent;

    var subtitle = document.querySelector('.bm-subtitle');

    if (subtitle) {
      subtitle.style.color = accent;
    }

    // Tint only the disclaimer using the SAME accent color
    if (modalDisclaimer) {
      modalDisclaimer.style.backgroundColor = colorToRgba(accent, 0.10);
    }

    modalTitle.textContent = selected;

    // Show link only for the main selected scent
    if (modalInfoLink) {
      if (infoHref) {
        modalInfoLink.href = infoHref;
        modalInfoLink.style.display = 'block';
      } else {
        modalInfoLink.removeAttribute('href');
        modalInfoLink.style.display = 'none';
      }
    }

    modalList.innerHTML = '';

    filtered.forEach(function (p) {
      var row = document.createElement('div');
      row.className = 'bm-partner-row';

      var n = document.createElement('div');
      n.className = 'bm-partner-name';
      n.textContent = p.partnerDisplay;

      var d = document.createElement('div');
      d.className = 'bm-partner-desc';

      setDescWithItalicMemory(d, p.desc);

      row.appendChild(n);
      row.appendChild(d);

      modalList.appendChild(row);
    });
  }

  // ---------- INLINE TRIGGER LINE ----------

  function buildUI(selectEl) {
    if (selectEl.__bmHelperMounted) return;

    selectEl.__bmHelperMounted = true;

    var wrap = document.createElement('div');
    wrap.className = 'bm-helper-wrap bm-helper-wrap--modal';

    var line = document.createElement('div');
    line.className = 'bm-helper-line';

    var text = document.createElement('span');
    text.className = 'bm-helper-text';

    var btn = document.createElement('button');
    btn.className = 'bm-helper-btn';
    btn.type = 'button';
    btn.style.display = 'none';
    btn.textContent = 'View pairings';

    line.appendChild(text);
    line.appendChild(btn);

    wrap.appendChild(line);

    var spbSelect = selectEl.closest('.spb-select');

    if (spbSelect) {
      spbSelect.insertAdjacentElement('afterend', wrap);
    } else {
      selectEl.insertAdjacentElement('afterend', wrap);
    }

    bindKillCapture(btn);

    function updateUI() {
      var selected = (selectEl.value || '').trim();

      closeModal();

      if (!selected) {
        text.textContent = '';
        btn.style.display = 'none';
        return;
      }

      var data = getBlendData();

      if (!data) {
        text.textContent = '';
        btn.style.display = 'none';
        return;
      }

      var selectedFragrance = resolveFragrance(selected);
      var entry = selectedFragrance && data[selectedFragrance.id];

      if (!entry || !entry.partners || !entry.partners.length) {
        text.textContent = '';
        btn.style.display = 'none';
        return;
      }

      var available = getAvailableOptions(selectEl);
      var availableSet = {};

      available.forEach(function (o) {
        availableSet[o.norm] = true;
      });

      var filtered = entry.partners.filter(function (p) {
        return !!availableSet[p.partnerNorm];
      });

      if (!filtered.length) {
        text.textContent = '';
        btn.style.display = 'none';
        return;
      }

      text.textContent = 'Suggested blends for ' + selectedFragrance.name;
      btn.style.display = 'inline';

      btn.onclick = function (e) {
        stopClick(e);

        fillModal(selectedFragrance.name, filtered);
        openModal();

        return false;
      };
    }

    selectEl.addEventListener('change', updateUI);

    updateUI();
  }

  function mount() {
    if (!BM_MODAL_ENABLED) return;

    // HARD GATE FIRST
    if (!isAllowedProduct()) return;

    var selectEl = document.querySelector(SELECT_S1);

    if (!selectEl) return;

    // Data must exist (your snippet)
    if (!document.querySelector(DATA_ROOT)) return;

    ensureModal();
    buildUI(selectEl);
  }

  document.addEventListener('DOMContentLoaded', mount);
  window.addEventListener('load', mount);

  var io = document.querySelector(IO_ROOT);

  if (io && window.MutationObserver) {
    new MutationObserver(function () {
      mount();
    }).observe(io, {
      childList: true,
      subtree: true
    });
  }
})();